import { Datepicker } from 'vanillajs-datepicker';

/* 1. QUOTE */
const form_date = document.querySelector('input[name="form_date"]');
if (form_date) {
  new Datepicker(form_date, {
    buttonClass: 'btn',
    language: 'en',
    autohide: 'true',
    minDate: 'today',
    format: 'mm/dd/yyyy'
  });
}
/* END QUOTE */

  
/* 2. BESPOKE WEDDING */
const eventDate = document.querySelector('input[name="eventDate"]');
if (eventDate) {
  new Datepicker(eventDate, {
    buttonClass: 'btn',
    language: 'en',
    autohide: 'true',
    minDate: 'today',
    format: 'mm/dd/yyyy'
  });
}

const arrivalDate = document.querySelector('input[name="arrivalDate"]');
if (arrivalDate) {
  new Datepicker(arrivalDate, {
    buttonClass: 'btn',
    language: 'en',
    autohide: 'true',
    minDate: 'today',
    format: 'mm/dd/yyyy'
  });
}

const departureDate = document.querySelector('input[name="departureDate"]');
if (departureDate) {
  new Datepicker(departureDate, {
    buttonClass: 'btn',
    language: 'en',
    autohide: 'true',
    minDate: 'today',
    format: 'mm/dd/yyyy'
  });
}
/* END BESPOKE WEDDING */


